import {
  alexandrKorsakPhoto,
  alexeyNemerovetsPhoto,
  anastasiyaKonovalenkovaPhoto,
  anatoliiZinchenkoPhoto,
  andreiKovinenokPhoto,
  andrewKiriiaPhoto,
  andrewLosPhoto,
  andriiIzvarinPhoto,
  antonValovPhoto,
  arniPhoto,
  artemGurzhiiPhoto,
  artemTutovPhoto,
  christineMatviienkoPhoto,
  daniilKaibulaievPhoto,
  danilSokolovskyPhoto,
  davidArutiunianPhoto,
  denisKomogorcevPhoto,
  dmitriiAlymovPhoto,
  dmitryBroshkovPhoto,
  dmytroKovalPhoto,
  ekaterinaNaumchikPhoto,
  evgeniiDolgopolovPhoto,
  folbPhoto,
  georgeViazemskyPhoto,
  giorgiBibilashviliPhoto,
  hakobPoghosyanPhoto,
  hannaKatanskaPhoto,
  hannaKlymenkoPhoto,
  ivanKlymenkoPhoto,
  javierLopezPhoto,
  kateOsyaginaPhoto,
  katerynaPolishkoPhoto,
  kirillMasharaPhoto,
  kyryloPapaianiPhoto,
  laptevPhoto,
  linaAleksandrovaPhoto,
  lyudaDziubynskaPhoto,
  maratBektimirovPhoto,
  maxRudkoPhoto,
  medetTleukabilulyPhoto,
  mishaYurchenkovPhoto,
  mykhailKaziutaPhoto,
  myroslavDorykevychPhoto,
  nikitaVylegzhaninPhoto,
  norbertPhoto,
  olgaIliukPhoto,
  olgaPhoto,
  olhaIievlievaPhoto,
  pangPhoto,
  pavelKhudyshkinPhoto,
  pavloDziubakPhoto,
  pavloVolovychPhoto,
  romanGoreglyadPhoto,
  semyonPupkovPhoto,
  sergeyBordiuhovPhoto,
  sergeyBordPhoto,
  sergeyKlubanPhoto,
  sergeyKucherPhoto,
  sergiiKorotenkoPhoto,
  serhiyKochkinPhoto,
  siarheiSukachPhoto,
  svyatoslavDardalanPhoto,
  tigranSahyakyanPhoto,
  ulianaShumilinaPhoto,
  vadimShalamovPhoto,
  vazgenVardevanyanPhoto,
  viktorOleksPhoto,
  vitalyAkulovPhoto,
  vladimirDyachokPhoto,
  vladimirTolstunovPhoto,
  vladislavTkachenkoPhoto,
  vladZarudenskyPhoto,
  volodimirKatanskyiPhoto,
  wangPhoto,
  yuriiShulichenkoPhoto,
  yuriKurantPhoto,
  yuriyPhoto,
  yuriYuzvovichPhoto,
} from 'Assets/_Legacy/Team'

import { POSITIONS_HELD } from './positionsHeld'

export const TEAM = {
  ARNOLD_SCHWARZENEGGER: {
    fullName: 'Arnold Schwarzenegger',
    image: arniPhoto,
    positions: [POSITIONS_HELD.FOUNDER, POSITIONS_HELD.CO_FOUNDER],
  },

  MARTIN_DAVID_FOLB: {
    fullName: 'Martin David Folb',
    image: folbPhoto,
    positions: [POSITIONS_HELD.HEAD_OF_SALES],
  },

  ALEXANDR_KORSAK: {
    fullName: 'Alexandr Korsak',
    image: alexandrKorsakPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  ANDREI_KOVINENOK: {
    fullName: 'Andrei Kovinenok',
    image: andreiKovinenokPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  ANASTASIYA_KONOVALENKOVA: {
    fullName: 'Anastasiya Konovalenkova',
    image: anastasiyaKonovalenkovaPhoto,
    positions: [POSITIONS_HELD.BUSINESS_ANALYST],
  },

  VOLODYMYR_KATANSKYI: {
    fullName: 'Volodymyr Katanskyi',
    image: volodimirKatanskyiPhoto,
    positions: [POSITIONS_HELD.CTO],
    positionsForTeamPage: 'Founder & CEO',
    text: 'Volodymyr has over 13 years of experience in software development and has studied Engineering and Multicultural Education. While travelling around the world, he invented the adaptive workflow framework that helped manage a team of around 100 team members, stay productive and scale. In his spare time Volodymyr loves learning online trained neural network modelling and building the tools and products to help remote working companies prosper.',
  },

  GEORGE_VIAZEMSKY: {
    fullName: 'George Viazemsky',
    image: georgeViazemskyPhoto,
    positions: [POSITIONS_HELD.LEAD_FRONTEND_ENGINEER],
    positionsForTeamPage: 'CIO & Co-Founder',
    text: 'George entered the industry 14 years ago as a software engineer and has already developed extensive experience at the different modern technologies stacks. It is hard to surprise him as he has an ability to quickly adapt to any new challenge. George holds a Master of Science degree in System Analysis and Management. In his free time George is managing another big project – his 2 kids. They help balance a stressful startup environment and charge him with positive energy.',
  },

  SERGEY_LAPTEV: {
    fullName: 'Sergey Laptev',
    image: laptevPhoto,
    positions: [POSITIONS_HELD.REACT_NATIVE_ENGINEER],
    positionsForTeamPage: 'CTO & Co-Founder',
    text: 'Sergey has been living with code in mind for the past 9 years. He holds a degree in Applied Informatics and Software Engineering. His main focus lies in mobile applications as he is a React Native guru. He constantly improves his skills experimenting with bleeding edge technologies, architecture patterns and always follows the latest trends. In the free time Sergey reads books, swims and explores the real estate business.',
  },

  KATERYNA_POLISHKO: {
    fullName: 'Kateryna Polishko',
    image: katerynaPolishkoPhoto,
    positions: [POSITIONS_HELD.COO],
    positionsForTeamPage: 'COO',
    text: 'Kateryna has over 10 years of managerial experience in Operations Departments. Having worked in different industries and international companies, she learned the best practices which now are applied in StartupCraft. Kateryna is an excellent communicator, a result-oriented professional, and always strives for process excellence and automation. Kateryna leads business operations with a cold mind while treating the team with heart.',
  },

  ALEXEY_NEMEROVETS: {
    fullName: 'Alexey Nemerovets',
    image: alexeyNemerovetsPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  ANDREW_LOS: {
    fullName: 'Andrew Los',
    image: andrewLosPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  ANTON_VALOV: {
    fullName: 'Anton Valov',
    image: antonValovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  ARTEM_GURZHII: {
    fullName: 'Artem Gurzhii',
    image: artemGurzhiiPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  DMITRII_ALYMOV: {
    fullName: 'Dmitrii Alymov',
    image: dmitriiAlymovPhoto,
    positions: [POSITIONS_HELD.REACT_NATIVE_ENGINEER],
  },

  ARTEM_TUTOV: {
    fullName: 'Artem Tutov',
    image: artemTutovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  CHRISTINE_MATVIIENKO: {
    fullName: 'Christine Matviienko',
    image: christineMatviienkoPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  DANIIL_KAIBULAIEV: {
    fullName: 'Daniil Kaibulaiev',
    image: daniilKaibulaievPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  DAVID_ARUTIUNIAN: {
    fullName: 'David Arutiunian',
    image: davidArutiunianPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  DENIS_KOMOGORCEV: {
    fullName: 'Denis Komogorcev',
    image: denisKomogorcevPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  DMITRY_BROSHKOV: {
    fullName: 'Dmitry Broshkov',
    image: dmitryBroshkovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  DMYTRO_KOVAL: {
    fullName: 'Dmytro Koval',
    image: dmytroKovalPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  HAKOB_POGHOSYAN: {
    fullName: 'Hakob Poghosyan',
    image: hakobPoghosyanPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  HANNA_KLYMENKO: {
    fullName: 'Hanna Klymenko',
    image: hannaKlymenkoPhoto,
    positions: [POSITIONS_HELD.CFO],
  },

  JAVIER_LOPEZ: {
    fullName: 'Javier Lopez',
    image: javierLopezPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  KIRILL_MASHARA: {
    fullName: 'Kirill Mashara',
    image: kirillMasharaPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  LYUDA_DZIUBYNSKA: {
    fullName: 'Lyuda Dziubynska',
    image: lyudaDziubynskaPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  MARAT_BEKTIMIROV: {
    fullName: 'Marat Bektimirov',
    image: maratBektimirovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  MAX_RUDKO: {
    fullName: 'Max Rudko',
    image: maxRudkoPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  MEDET_TLEUKABILULY: {
    fullName: 'Medet Tleukabiluly',
    image: medetTleukabilulyPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  MISHA_YURCHENKOV: {
    fullName: 'Misha Yurchenkov',
    image: mishaYurchenkovPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  MYKHAIL_KAZIUTA: {
    fullName: 'Mykhail Kaziuta',
    image: mykhailKaziutaPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  NORBERT: {
    fullName: 'Norbert',
    image: norbertPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  NIKITA_VYLEGZHANIN: {
    fullName: 'Nikita Vylegzhanin',
    image: nikitaVylegzhaninPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  OLGA_ILIUK: {
    fullName: 'Olga Iliuk',
    image: olgaIliukPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  OLHA_IIEVLIEVA: {
    fullName: 'Olha Iievlieva',
    image: olhaIievlievaPhoto,
    positions: [POSITIONS_HELD.BUSINESS_ANALYST],
  },

  PANG: {
    fullName: 'Pang',
    image: pangPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  PAVEL_KHUDYSHKIN: {
    fullName: 'Pavel Khudyshkin',
    image: pavelKhudyshkinPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  SEMYON_PUPKOV: {
    fullName: 'Semyon Pupkov',
    image: semyonPupkovPhoto,
    positions: [POSITIONS_HELD.SENIOR_BACKEND_ENGINEER],
  },

  SERGEY_BORDIUHOV: {
    fullName: 'Sergey Bordiuhov',
    image: sergeyBordiuhovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  SERHIY_KOCHKIN: {
    fullName: 'Serhiy Kochkin',
    image: serhiyKochkinPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  SERGEY_KLUBAN: {
    fullName: 'Sergey Kluban',
    image: sergeyKlubanPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  SERGEY_KUCHER: {
    fullName: 'Sergey Kucher',
    image: sergeyKucherPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  SERGII_KOROTENKO: {
    fullName: 'Sergii Korotenko',
    image: sergiiKorotenkoPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  SVYATOSLAV_DARDALAN: {
    fullName: 'Svyatoslav Dardalan',
    image: svyatoslavDardalanPhoto,
    positions: [POSITIONS_HELD.SENIOR_FRONTEND_ENGINEER],
  },

  TIGRAN_SAHYAKYAN: {
    fullName: 'Tigran Sahyakyan',
    image: tigranSahyakyanPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  ULIANA_SHUMILINA: {
    fullName: 'Uliana Shumilina',
    image: ulianaShumilinaPhoto,
    positions: [POSITIONS_HELD.SOFTWARE_DEVELOPER],
  },

  VADIM_SHALAMOV: {
    fullName: 'Vadim Shalamov',
    image: vadimShalamovPhoto,
    positions: [POSITIONS_HELD.LEAD_BACKEND_ENGINEER],
  },

  VAZGEN_VARDEVANYAN: {
    fullName: 'Vazgen Vardevanyan',
    image: vazgenVardevanyanPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  VIKTOR_OLEKS: {
    fullName: 'Viktor Oleks',
    image: viktorOleksPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  VITALY_AKULOV: {
    fullName: 'Vitaly Akulov',
    image: vitalyAkulovPhoto,
    positions: [POSITIONS_HELD.SENIOR_FRONTEND_ENGINEER],
  },

  VLAD_ZARUDENSKY: {
    fullName: 'Vlad Zarudensky',
    image: vladZarudenskyPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  VLADIMIR_DYACHOK: {
    fullName: 'Vladimir Dyachok',
    image: vladimirDyachokPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  VLADIMIR_TOLSTUNOV: {
    fullName: 'Vladimir Tolstunov',
    image: vladimirTolstunovPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  VLADISLAV_TKACHENKO: {
    fullName: 'Vladislav Tkachenko',
    image: vladislavTkachenkoPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  WANG: {
    fullName: 'Wang',
    image: wangPhoto,
    positions: [POSITIONS_HELD.REACT_NATIVE_ENGINEER],
  },

  YURI_KURANT: {
    fullName: 'Yuri Kurant',
    image: yuriKurantPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  YURI_YUZVOVICH: {
    fullName: 'Yuri Yuzvovich',
    image: yuriYuzvovichPhoto,
    positions: [POSITIONS_HELD.VR_AR_ENGINEER],
  },

  YURII_SHULICHENKO: {
    fullName: 'Yurii Shulichenko',
    image: yuriiShulichenkoPhoto,
    positions: [POSITIONS_HELD.BUSINESS_ANALYST],
  },

  ANDREW_KIRIIA: {
    fullName: 'Andrew Kiriia',
    image: andrewKiriiaPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  SERGEY_BORD: {
    fullName: 'Sergey Bord',
    image: sergeyBordPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  YURIY_GORGOLYUK: {
    fullName: 'Yuriy Gorgolyuk',
    image: yuriyPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  KATE_OSYAGINA: {
    fullName: 'Kate Osyagina',
    image: kateOsyaginaPhoto,
    positions: [POSITIONS_HELD.REACT_NATIVE_ENGINEER],
  },

  MYROSLAV_DORYKEVYCH: {
    fullName: 'Myroslav Dorykevych',
    image: myroslavDorykevychPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  OLGA_KUZNETSOVA: {
    fullName: 'Olga Kuznetsova',
    image: olgaPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  ANDRII_IZVARIN: {
    fullName: 'Andrii Izvarin',
    image: andriiIzvarinPhoto,
    positions: [POSITIONS_HELD.BACKEND_DEVELOPER],
  },

  GIORGI_BIBILASHVILI: {
    fullName: 'Giorgi Bibilashvili',
    image: giorgiBibilashviliPhoto,
    positions: [POSITIONS_HELD.REACT_NATIVE_ENGINEER],
  },

  EVGENII_DOLGOPOLOV: {
    fullName: 'Evgenii Dolgopolov',
    image: evgeniiDolgopolovPhoto,
    positions: [POSITIONS_HELD.REACT_DEVELOPER],
  },

  ANATOLII_ZINCHENKO: {
    fullName: 'Anatolii Zinchenko',
    image: anatoliiZinchenkoPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  SIARHEI_SUKACH: {
    fullName: 'Siarhei Sukach',
    image: siarheiSukachPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  LINA_ALEKSANDROVA: {
    fullName: 'Lina Aleksandrova',
    image: linaAleksandrovaPhoto,
    positions: [POSITIONS_HELD.BACKEND_ENGINEER],
  },

  EKATERINA_NAUMCHIK: {
    fullName: 'Ekaterina Naumchik',
    image: ekaterinaNaumchikPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  IVAN_KLYMENKO: {
    fullName: 'Ivan Klymenko',
    image: ivanKlymenkoPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  KYRYLO_PAPAIANI: {
    fullName: 'Kyrylo Papaiani',
    image: kyryloPapaianiPhoto,
    positions: [POSITIONS_HELD.QUALITY_ASSURANCE_ENGINEER],
  },

  PAVLO_VOLOVYCH: {
    fullName: 'Pavlo Volovych',
    image: pavloVolovychPhoto,
    positions: [POSITIONS_HELD.FRONTEND_ENGINEER],
  },

  DANIL_SOKOLOVSKY: {
    fullName: 'Danil Sokolovsky',
    image: danilSokolovskyPhoto,
    positions: [POSITIONS_HELD.BACKEND_DEVELOPER],
  },

  PAVLO_DZIUBAK: {
    fullName: 'Pavlo Dziubak',
    image: pavloDziubakPhoto,
    positions: [POSITIONS_HELD.PROJECT_MANAGER],
  },

  ROMAN_GOREGLYAD: {
    fullName: 'Roman Goreglyad',
    image: romanGoreglyadPhoto,
    positions: [POSITIONS_HELD.DESIGNER_UI_UX],
  },

  HANNA_KATANSKA: {
    fullName: 'Hanna Katanska',
    image: hannaKatanskaPhoto,
    positions: [POSITIONS_HELD.SOFTWARE_DEVELOPER],
  },
}
